import { concatPagination } from '@apollo/client/utilities';

export const APP_QUERY_FIELD_POLICIES = {
  posts_comments: concatPagination(['$postId']),
};
